import { USER_PROFILE_GROUPS_READ_REQUEST, USER_PROFILE_GROUPS_READ_SUCCESS, USER_PROFILE_GROUPS_READ_FAILURE } from '../../constants/user_profile_groups.constants';

export const userProfileGroupsReadRequest = params => ({
    type: USER_PROFILE_GROUPS_READ_REQUEST, params,
});

export const userProfileGroupsReadSuccess = payload => ({
    type: USER_PROFILE_GROUPS_READ_SUCCESS, payload,
});

export const userProfileGroupsReadFailure = error => ({
    type: USER_PROFILE_GROUPS_READ_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_profile_groups_actions/user_profile_groups_read.actions.js